// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.7.1_@swc+helpers@0.5.23__webpack@5.98.0_@swc+core@1.15._207d30a1a39a4eca1cd7ece3f0ffaa06/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
visiba-registration {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
visiba-registration .regContainer {
  display: block;
  overflow-y: scroll;
  width: 100vw;
  height: 100vh;
}
@media screen and (max-width: 905px) {
  visiba-registration {
    width: 100vw;
    height: 100vh;
  }
  visiba-registration .registration-fields > * {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 8px;
  }
}
visiba-registration .overlay {
  background: var(--c_mainOverlayBackground);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
visiba-registration .container {
  margin-top: 120px;
  position: relative;
  pointer-events: none;
}
@media screen and (max-width: 905px) {
  visiba-registration .container {
    width: 100%;
    display: flex;
    align-items: center;
    margin-top: 0;
    overflow: auto;
  }
}
visiba-registration .inner {
  background: var(--c_backgroundBox);
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.4);
  padding: 40px 0;
  pointer-events: all;
  border-radius: 16px;
}
@media screen and (max-width: 905px) {
  visiba-registration .inner {
    width: auto !important;
    margin: 0 8px !important;
  }
}
visiba-registration .inner .icon {
  margin-bottom: 16px;
  text-align: center;
}
visiba-registration .inner .icon visiba-svg {
  width: 60px;
}
visiba-registration .inner .intro {
  text-align: center;
}
@media screen and (max-width: 905px) {
  visiba-registration .inner .intro {
    margin: 0 !important;
    width: 100% !important;
  }
}
visiba-registration .inner visiba-nin,
visiba-registration .inner visiba-input,
visiba-registration .inner visiba-tel {
  margin-bottom: 30px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
